module.exports = __webpack_public_path__ + "static/media/A4-landscape-v2.13a6d117.png";